import { Link } from "react-router-dom";
import React, {useEffect} from "react";
import Aos from "aos";
import "aos/dist/aos.css"


function HeroPages({ name }) {
  useEffect(()=>{
    Aos.init()
  },[])


  return (
    <>
      <section className="hero-pages" data-aos="fade-down">
        <div className="hero-pages__overlay"></div>
        <div className="container">
          <div className="hero-pages__text">
            <h3>{name}</h3>
            <p>
              <Link to="/">Home</Link> / Servicios
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default HeroPages;
